import React, { useState } from "react";
import MaterialIcon from "../../../components/MaterialIcon";
import { CompanyAdminEmbed } from "../../Company/CompanyAdmin";

/**
 * "Room & Chat Management" on the company tab: the admin app's rooms section,
 * mounted only once opened so the company tab keeps a single iframe by default.
 */
export default function CockpitRoomAdminCard({ strings, companyId }) {
  const [open, setOpen] = useState(false);
  return (
    <section className={`cockpit-card cockpit-acc cockpit-room-admin${open ? " cockpit-acc--open" : ""}`}>
      <button type="button" className="cockpit-room-admin-toggle" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <span className="cockpit-acc-icon cockpit-acc-icon--accent">
          <MaterialIcon icon="meeting_room" size={20} color="currentColor" weight={400} />
        </span>
        <span className="cockpit-acc-text">
          <span className="cockpit-acc-title">{strings.cockpit_room_admin || "Project & Chat Management"}</span>
          {/* Once open the section shows the same hint in its own description row. */}
          {open ? null : (
            <span className="cockpit-acc-subtitle">
              {strings.cockpit_room_admin_sub ||
                "Alle Projekte der Firma mit Mitgliedern, Medien und Chats."}
            </span>
          )}
        </span>
        <MaterialIcon icon="expand_more" size={20} color="#7c8493" className="cockpit-acc-chev" />
      </button>
      {open ? (
        <div className="cockpit-acc-body cockpit-room-admin-body">
          <CompanyAdminEmbed companyId={companyId} section="rooms" bare flush className="is-settings" />
        </div>
      ) : null}
    </section>
  );
}
